
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { CompanyStatusSummaryModel } from 'models/generated/GormGateway.Models.CompanyStatusSummary';
import { ApproveCompanyForSaleResponseModel } from 'models/generated/GormGateway.Models.ApproveCompanyForSaleResponse';


const _gormGateway_CompanyControllerHelper = new Map<string, Object>();
_gormGateway_CompanyControllerHelper.set('GetCompaniesStatus', CompanyStatusSummaryModel);
_gormGateway_CompanyControllerHelper.set('CompanySaleAllowed', ApproveCompanyForSaleResponseModel);
_gormGateway_CompanyControllerHelper.set('GetCompanyStatus', CompanyStatusSummaryModel);


export const gormGateway_CompanyControllerHelper = _gormGateway_CompanyControllerHelper;

